/* eslint-env browser */
(function () {
  const THROTTLE_MS = 30 * 60 * 1000; // 30 minutes
  const LAST_KEY = 'homePopupLastShown';

  function now() {return Date.now(); }
  function lastShown() {return parseInt(localStorage.getItem(LAST_KEY) || '0', 10); }
  function shouldShow() {return now() - lastShown() >= THROTTLE_MS; }
  function markShown() {localStorage.setItem(LAST_KEY, String(now())); }

  function open(el, backdrop) {
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    backdrop.classList.add('is-open');
    backdrop.removeAttribute('hidden')
    document.body.classList.add('no-scroll')
  } 

  function close(el, backdrop) {
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    backdrop.classList.remove('is-open');
    backdrop.setAttribute('hidden', 'hidden')
    document.body.classList.remove('no-scroll')
  }

  function init() {
    if (!document.body.classList.contains('home-page')) return;

    const popup = document.getElementById('home-popup');
    const backdrop = document.getElementById('home-popup-backdrop');
    if (!popup || !backdrop) return;

    const closeBtn = popup.querySelector('.popup__close');

    function handleClose() { close(popup, backdrop); }

    closeBtn && closeBtn.addEventListener('click', handleClose);
    backdrop.addEventListener('click', handleClose);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') handleClose();
    })

    if (shouldShow()) {
      setTimeout(() => {
        open(popup, backdrop);
        markShown();
      }, 800);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
